import { render } from "./AffiliatePayout.vue?vue&type=template&id=992e2b4c&scoped=true"
import script from "./AffiliatePayout.vue?vue&type=script&lang=js"
export * from "./AffiliatePayout.vue?vue&type=script&lang=js"

import "./AffiliatePayout.vue?vue&type=style&index=0&id=992e2b4c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3818363008/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-992e2b4c"]])

export default __exports__